import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'

let serverUrl = getSecret('SERVER_URL')

export const state = {
  cached: {},
}

export const getters = {}

export const mutations = {
  CACHE_APP_SECTIONS(state, appSections) {
    state.cached = appSections
  },
}

export const actions = {

  init({ state, dispatch }) {},

  fetchAppSections(context, query) {
    query = query || ''
    return axios.get(`${serverUrl}/base/app-sections/${query}`).then((response) => {
      const request = response.data
      context.commit('CACHE_APP_SECTIONS', request)
      return request
    })
  },
  fetchAppSectionsDetail(context, url) {
    return axios.get(url).then((response) => {
      return response.data
    })
  },

  createUpdateAppSections(context, formData) {
    let promise = null
    if (formData.url){
      promise =  axios.put(formData.url, formData)
    }else {
      promise =  axios.post(`${serverUrl}/base/app-sections/`, formData)
    }
    return promise.then(
      (response) => {
        return response.data
      }
    )
  },
  deleteAppSections(context, permUrl) {
    let promise = null
    promise =  axios.delete(permUrl)
    return promise.then(
      (response) => {
        return response.data
      }
    )
  }
}